import { useSceneEvents } from "@/components/common/scene-events-context";
import { RenderDispatch } from "@/modes/flywalk-mode/rendering-pipeline/render-dispatch";
import {
  FilteredRenderPass,
  useTypedEvent,
  type FilteredRenderPassProps,
  type FilteredRenderPassRef,
} from "@faro-lotv/app-component-toolbox";
import { useCallback, useRef, type JSX } from "react";
import type { Object3D } from "three";

type SplatFilteredPassProps = Pick<
  FilteredRenderPassProps,
  "enabled" | "renderOnDemand"
>;

/** @returns A filtered pass invalidated whenever the Gaussian splat scene changes */
export function SplatFilteredPass({
  enabled,
  renderOnDemand,
}: SplatFilteredPassProps): JSX.Element {
  const passRef = useRef<FilteredRenderPassRef>(undefined);
  const invalidate = useCallback(() => passRef.current?.invalidate(), []);
  const { invalidateGaussianSplatsScene } = useSceneEvents();
  useTypedEvent(invalidateGaussianSplatsScene, invalidate);

  return (
    <FilteredRenderPass
      ref={passRef}
      enabled={enabled}
      filter={(obj: Object3D) =>
        obj.userData.type === RenderDispatch.GaussianSplatsPass
      }
      clear={false}
      clearDepth={false}
      renderOnDemand={renderOnDemand}
    />
  );
}
